export default __webpack_public_path__ + "static/media/icon-plus.9845a564.svg";